import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as edu from "./style.module.scss";

export const Education = () => {
  return (
    <section className={edu.education} id="structure">
      <div className="container">
        <h2 className={`${main.titleH2} ${edu.education__title}`}>
          Как проходит обучение в&nbsp;мини-группах?
        </h2>
        <div className={edu.education__blocks}>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/icon-how-01.png" alt=""/>
            <div className={edu.education__blockText}>
              <strong>Ежедневно</strong> в&nbsp;15:00 (по&nbsp;Мск) дети получают в&nbsp;чате задание
            </div>
          </div>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/kurs-icon-01.png" alt=""/>
            <div className={edu.education__blockText}>
              Задание необходимо выполнить <strong>не&nbsp;позднее 15:00</strong> (по&nbsp;Мск) следующего дня
            </div>
          </div>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/icon-how-03.png" alt=""/>
            <div className={edu.education__blockText}>
              Ориентировочное время выполнения задания&nbsp;&mdash; <strong>30&nbsp;минут</strong>
            </div>
          </div>
          <div className={edu.education__block}>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/icon-how-04.png" alt=""/>
            <div className={edu.education__blockText}>
              <strong>Куратор разбирает</strong> пройденные темы и&nbsp;отвечает на&nbsp;вопросы (задать их&nbsp;можно в&nbsp;чате в&nbsp;любое время)
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
